/** Clave en localStorage para mostrar/ocultar la puntuación en perfiles y tarjetas */
export const SHOW_SCORE_STORAGE_KEY = "candidatos_show_score";

/** Clave en localStorage para mostrar/ocultar cursores en tiempo real (propios y remotos). */
export const SHOW_CURSORS_STORAGE_KEY = "candidatos_show_cursors";

/** Devuelve true si debe mostrarse el score (por defecto true). */
export function getShowScore() {
  try {
    const v = localStorage.getItem(SHOW_SCORE_STORAGE_KEY);
    return v === null ? true : v === "true";
  } catch {
    return true;
  }
}

/** Devuelve true si deben mostrarse los cursores (por defecto true). */
export function getShowCursors() {
  try {
    const v = localStorage.getItem(SHOW_CURSORS_STORAGE_KEY);
    return v === null ? true : v === "true";
  } catch {
    return true;
  }
}

/** Notifica que las opciones han cambiado (para que CursorPresence etc. se actualicen). */
export function notifySettingsChanged() {
  try {
    window.dispatchEvent(new CustomEvent("candidatos-settings-changed"));
  } catch (_) {}
}
